import { regularFont, semiBoldFont } from "@app/styles";
import styled from "styled-components";

export const ClassroomList = styled.div`
min-height: 500px;
max-height: 600px;
overflow: auto;
padding: 0 8px 0 0;
margin-bottom: 24px;
position: relative;
`

export const Label = styled.label`
display: block;
font-size: 14px;
${semiBoldFont};
margin-bottom: 8px;
`

export const Value = styled.p`
font-size: 16px;
${regularFont};
line-height: 1.35;
margin: 0;
`